<template>
  <div class="data-manage">
    <div style="display: flex; background: #ffffff">
      <div
        style="
          padding: 11px 14px 0px 19px;
          border-bottom: 1px solid rgb(232 232 232);
          height: 44px;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #000000 !important;
        "
      >
        异常类型：
      </div>
      <a-tabs v-model="search.exceptionClass" style="flex: 1" class="oneTab" @change="handleSearch">
        <a-tab-pane :key="'全部'" tab="全部"> </a-tab-pane>
        <a-tab-pane :key="0" tab="爬取异常" force-render> </a-tab-pane>
        <a-tab-pane :key="1" tab="标题解析异常"> </a-tab-pane>
        <a-tab-pane :key="2" tab="正文解析异常"> </a-tab-pane>
        <a-tab-pane :key="3" tab="时间解析异常"> </a-tab-pane>
        <a-tab-pane :key="4" tab="文件解析异常"> </a-tab-pane>
      </a-tabs>
    </div>

    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      style="padding-top: 2px"
      ref="condition"
      class="layoutStyle"
    >
      <star-condition-cell label="处理状态">
        <a-select v-model="search.solveStatus" style="width: 100%">
          <!-- 待处理、已处理、已忽略 -->
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option :value="0"> 已忽略</a-select-option>
          <a-select-option :value="1"> 待处理</a-select-option>
          <a-select-option :value="2">已处理 </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="处理时间">
        <a-range-picker
          style="width: 100%"
          v-model="search.publishTime"
          :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['开始日期', '结束日期']"
        />
      </star-condition-cell>
      <star-condition-cell label="处理人员">
        <a-select
          v-model="search.userId"
          style="width: 100%"
          :filter-option="filterOption"
          show-search
        >
          <a-select-option value="全部"> 全部</a-select-option>
          <!-- <a-select-option value="人员1"> 人员1</a-select-option>
          <a-select-option value="人员2"> 人员2</a-select-option> -->
          <a-select-option v-for="(item, index) in peopleGroup" :key="index" :value="item.userId">
            {{ item.userName }}</a-select-option
          >
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="站点类型">
        <a-select v-model="search.siteType" style="width: 100%">
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option v-for="item in spiderClassOptions" :key="item.type" :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点名称">
        <a-input v-model="search.siteName" placeholder="请输入站点名称" />
      </star-condition-cell>
      <star-condition-cell label="站点id">
        <a-input v-model="search.siteId" placeholder="请输入站点id" />
      </star-condition-cell>
      <star-condition-cell label="异常编号">
        <a-input v-model="search.exceptionCode" placeholder="请输入异常编号" />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <!-- <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button> -->
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="userId"
        :columns="showColumns"
        :dataSource="dataSource"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="siteId" slot-scope="text">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <span>
              {{ text }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>
        <span slot="siteType" slot-scope="text, record">{{ returnSiteType(record.siteType) }}</span>
        <span slot="degreeImport" slot-scope="text, record">{{
          returnDegreeImport(record.degreeImport)
        }}</span>
        <span slot="solveStatus" slot-scope="text, record">
          <div style="display: flex" v-if="record.solveStatus == 2">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #1890ff;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已处理</div>
          </div>
          <div style="display: flex" v-if="record.solveStatus == 1">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #f5222d;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>待处理</div>
          </div>
          <div style="display: flex" v-if="record.solveStatus == 0">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #ffa720;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已忽略</div>
          </div>
        </span>
        <span slot="userName" slot-scope="text">{{ text ? text : '--' }}</span>
        <span slot="siteName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <a @click="openWindow(record)">
              {{ returnSiteName(text) }}
            </a>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>
        <span slot="allotStatus" slot-scope="text, record">{{
          returnAllotStatus(record.allotStatus)
        }}</span>
        <span slot="exceptionClass" slot-scope="text, record">{{
          returnexceptionClass(record.exceptionClass)
        }}</span>
        <span slot="nextSolveStatus" slot-scope="text, record">
          <div style="display: flex" v-if="record.nextSolveStatus == 2">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #1890ff;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已处理</div>
          </div>
          <div style="display: flex" v-if="record.nextSolveStatus == 1">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #f5222d;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>待处理</div>
          </div>
          <div style="display: flex" v-if="record.nextSolveStatus == 0">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #ffa720;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>已忽略</div>
          </div>
        </span>
        <span slot="exceptionCode" slot-scope="text, record">
          <a-tag color="blue">{{ record.exceptionCode }}</a-tag>
        </span>
        <span slot="preAlertsTime" slot-scope="text, record">{{
          record.preAlertsTime ? record.preAlertsTime + '~' + record.nextAlertsTime : ''
        }}</span>
        <span slot="monitorHz" slot-scope="text, record">{{ text + '天/次' }}</span>
        <span slot="groupId" slot-scope="text, record">{{ returnGroupId(record.groupId) }}</span>
        <span slot="groupMemberId" slot-scope="text, record">{{
          returnGroupMemberId(record.groupMemberId)
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleStuteRz(record)"> 处理日志 </a>
        </div>
      </a-table>
    </div>
    <a-drawer
      :title="formModel == null ? '新增用户' : '修改用户'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
    <ModelRZ ref="ModelRZ"></ModelRZ>
  </div>
</template>

<script>
import { queryUserApi } from '@/api/System/User'
import { deleteUserApi } from '@/api/System/User'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { monitorloginfo } from '@/api/Monitor/abnormal'
import { info } from '@/api/System/User'
import Clipboard from 'clipboard'
// import moment from 'moment'
import Form from './Form.vue'
import ModelRZ from './modelRZ.vue'

export default {
  data() {
    return {
      tableDensity: 'middle',
      loading: false,
      visible: false,
      spiderClassOptions: [],
      search: {
        publishTime: [],
        userId: '全部',
        solveStatus: '全部',
        siteType: '全部',
        exceptionClass: '全部'
      },
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'left',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '异常编号',
          dataIndex: 'exceptionCode',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'exceptionCode' }
        },
        {
          title: '异常类型',
          dataIndex: 'exceptionClass',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'exceptionClass' }
        },
        {
          title: '站点类型',
          dataIndex: 'siteType',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteType' }
        },
        {
          title: '站点名称',
          dataIndex: 'siteName',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteName' }
        },
        {
          title: '站点Id',
          dataIndex: 'siteId',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteId' }
        },

        {
          title: '检测时间',
          dataIndex: 'preAlertsTime',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'preAlertsTime' }
        },
        {
          title: '处理状态',
          dataIndex: 'solveStatus',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'solveStatus' }
        },
        {
          title: '处理人员',
          show: true,
          dataIndex: 'userDto.userName',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '处理时间',
          show: true,
          dataIndex: 'solveTime',
          scopedSlots: { customRender: 'userName' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          align: 'left'
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      formModel: null,
      peopleGroup: []
    }
  },
  created() {
    this.getTableList()
    this.querySpiderClassInfo()
    this.leftData()
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    returnSiteName(item) {
      if (item) {
        if (item.length > 20) {
          const str = item.substring(0, 21)
          return str + '...'
        } else {
          return item
        }
      } else {
        return ''
      }
    },
    openWindow(record) {
      window.open('/#/site_info?' + 'spiderId=' + record.siteId + '&type=' + record.siteType)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async leftData() {
      let query = {
        pn: 1,
        pageSize: 999999
      }
      this.loading = true
      let res = await queryUserApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      this.peopleGroup = data
    },
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    reset() {
      this.search = {
        publishTime: [],
        userId: '全部',
        solveStatus: '全部',
        siteType: '全部',
        exceptionClass: '全部'
      }
      this.getTableList()
    },
    handleAdd() {
      this.formModel = null
      this.visible = true
    },

    handleStuteRz(record) {
      this.$refs.ModelRZ.showModel(record)
    },
    handleSearch() {
      this.pagination.current = 1
      this.getTableList()
    },

    handleRefresh() {
      this.pagination.current = 1
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.userName = ''
      this.search.phone = ''
      this.search.mail = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete({ userId }) {
      const res = await deleteUserApi({ userId })
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    async getTableList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search
      }
      for (let i in query) {
        if (query[i] === '全部') {
          query[i] = undefined
        }
      }
      delete query.publishTime
      if (this.search.publishTime.length > 0) {
        query.startSolveTime = this.search.publishTime[0]
        query.endSolveTime = this.search.publishTime[1]
      
      }
      this.loading = true
      let res = await monitorloginfo(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.dataSource = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },
    returnSiteType(data) {
      let a = ''
      this.spiderClassOptions.forEach((element) => {
        if (element.type === data) {
          a = element.spiderClassName
        }
      })
      return a
    },
    returnenextSolveStatus(data) {
      switch (data) {
        case 0:
          return '已忽略'
        case 1:
          return '待处理'
        case 2:
          return '已处理'

        default:
          break
      }
    },
    returnAllotStatus(data) {
      switch (data) {
        case 0:
          return '待分配'
        case 1:
          return '已分配'

        default:
          break
      }
    },
    returnexceptionClass(data) {
      //       <a-tab-pane :key="0" tab="爬取异常" force-render> </a-tab-pane>
      // <a-tab-pane :key="1" tab="标题解析异常"> </a-tab-pane>
      // <a-tab-pane :key="2" tab="正文解析异常"> </a-tab-pane>
      // <a-tab-pane :key="3" tab="时间解析异常"> </a-tab-pane>
      // <a-tab-pane :key="4" tab="文件解析异常"> </a-tab-pane>
      switch (data) {
        case 0:
          return '爬取异常'
        case 1:
          return '标题解析异常'
        case 2:
          return '正文解析异常'
        case 3:
          return '时间解析异常'
        case 4:
          return '文件解析异常'

        default:
          break
      }
    },
    returnDegreeImport(data) {
      // let list = {(0:未知，1：一般，2：重要，3：非常重要}
      switch (data) {
        case 0:
          return '未知'
        case 1:
          return '一般'
        case 2:
          return '重要'
        case 3:
          return '非常重要'

        default:
          break
      }
    },
    returnGroupId(data) {
      let a = ''
      this.dataGroupCopy.forEach((element) => {
        if (element.id === data) {
          a = element.groupName
        }
      })
      return a
    },
    returnGroupMemberId(data) {
      let a = ''
      this.peopleGroupCopy.forEach((element) => {
        if (element.userId === data) {
          a = element.userDto.userName
        }
      })
      return a
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  },
  components: {
    Form,
    ModelRZ
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    margin-top: 16px;
    background: #fff;
    padding: 0 20px 0 20px;
  }
}
</style>
<style scoped>
.oneTab /deep/ .ant-tabs-nav .ant-tabs-tab {
  /* margin-left: 40px !important; */
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #000000 !important;
}
</style>
<style scoped>
.layoutStyle /deep/ .actions {
  width: 100px;
}
</style>
